import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Label from "../Utils/FormInputs/Label";
import Col from "react-bootstrap/Col";
import TextField from "../Utils/FormInputs/TextField";
import {CustomSelect} from "../Utils/FormInputs/SelectInput";
import {titleCase} from "../Users/addUser";
import {ReusablePhoneInput} from "../Utils/FormInputs/FormGroup";
import moment from "moment";
import Textarea, {ResizableTextarea} from "../Utils/FormInputs/Textarea";
import { ErrorMessage } from "../Utils/styledComponents";

const AddSchedule = ({
                             handleChange,
                             handleSubmit,
                             state,
                             submitted,
                             isSubmitted,
                             addSchedule,
                             handleChangeStaff,
                             staff_name,
                             employees,
                             phone,
                             setPhone
                         }) => {
    const {patient_time, slot_name, start_period, end_period, doctor_name, description} = state;
    const date = new Date();
    const current_date = moment(date).format().split('T')[0];
    return (

            <form onSubmit={handleSubmit} autoComplete="off">
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                <Label  name="Slot Name" htmlFor='slot_name' type/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} xl={7}>

                                <TextField  {...{submitted}} value={titleCase(slot_name)} id='slot_name' onChange={handleChange} type="text"
                                           name="slot_name" data-testid="slot-name"/>
                                {(submitted && !slot_name) &&
                                <ErrorMessage>Slot name is required</ErrorMessage>}
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                <Label name="Description" htmlFor='description'/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} xl={7}>

                                <ResizableTextarea value={titleCase(description)} onChange={handleChange}
                                           name="description" id="description" rows={2}/>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                <Label  name="Doctor Name" htmlFor='doctor_name' type/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} xl={7}>
                                {staff_name.value === 'other' ?
                                    <TextField  {...{submitted}} value={doctor_name ? titleCase(doctor_name) : doctor_name}
                                               onChange={handleChange} type="text" id='doctor_name' 
                                               name="doctor_name"/>
                                    : <CustomSelect   onChange={handleChangeStaff} value={staff_name} options={employees}
                                                    dataTest="staff_name" id="doctor_name" />}
                                {(submitted && !staff_name) &&
                                <ErrorMessage>Doctor name is required</ErrorMessage>}
                            </Col>
                        </Form.Group>

                        {staff_name ? <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                <Label  name="Contact" htmlFor='contact' />
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} xl={7}>

                                <ReusablePhoneInput submitted={submitted} required contact={phone} id='contact' setContact={setPhone}
                                disabled={addSchedule && staff_name.value !== 'other'}/>

                            </Col>
                        </Form.Group> : null}

                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                <Label  name="Date Scheduled" htmlFor='dateScheduled' type/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} xl={7}>

                                <TextField  {...{submitted}} value={patient_time} id='dateScheduled' onChange={handleChange} type="date"
                                           name="patient_time"/>
                                {(submitted && !patient_time) ?
                                <ErrorMessage>Date scheduled is required</ErrorMessage> :
                                    (patient_time && patient_time < current_date) && <ErrorMessage>Please select current or future date</ErrorMessage>}
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                <Label  name="Available Time" htmlFor='availableTime' type/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} xl={7}>
                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <TextField  {...{submitted}} value={start_period} id='availableTime' onChange={handleChange} type="time"
                                                   name="start_period" placeholder="Start Time"/>
                                        {(submitted && !start_period) &&
                                        <ErrorMessage>Start Time is required</ErrorMessage>}

                                    </Col>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <TextField  {...{submitted}} value={end_period} id='endTime' onChange={handleChange} type="time"
                                                   name="end_period"
                                                   placeholder="End Time"/>
                                        {(submitted && !end_period) ?
                                        <ErrorMessage>End Time is required</ErrorMessage> :
                                            (end_period && end_period < start_period) &&  <ErrorMessage>End Time should be greater than start time</ErrorMessage> }
                                    </Col>
                                </Row>
                            </Col>
                        </Form.Group>
                        <div className="text-right mr-5">
                         
                            
                            <button type="submit" className="btn btn-sm sms-btn px-4"
                                    disabled={isSubmitted === 'pending'}
                                    data-testid="submit-schedule">
                                {isSubmitted === 'pending' ? "Saving..." : "Save"}</button>
                        </div>
                    </form>

    )
};


export default AddSchedule;
